var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"type":"is-primary is-outlined","size":"is-large"},on:{"click":_vm.attemptNUConnectLogin}},[_c('img',{attrs:{"src":require("@/assets/nu-logo.png")}}),_vm._v(" Free with NU account ")])}
var staticRenderFns = []

export { render, staticRenderFns }